export const ACCOUNTING_QUERY_KEYS = {
  BOOKKEEPING_STATUS: 'accountingBookkeepingStatus',
  MAGIC_LINK: 'accountingMagicLink',
  BALANCE_SHEET: 'accountingBalanceSheet',
  CLIENT: 'accountingClient',
  INCOME_STATEMENT: 'accountingIncomeStatement',
  TOP_EXPENSES: 'accountingTopExpenses',
  PROFIT_AND_LOSS: 'accountingProfitAndLoss',
  ORGANIZATION_SETTINGS: 'accountingOrganizationSettings',
  NOTIFICATION: 'accountingNotification',
  NOTIFICATIONS_TOTAL_COUNT: 'accountingNotificationsTotalCount',
  REPORTS: 'accountingReports',
  SETUP_INITIAL_DATA: 'accountingSetupInitialData',
  HEALTH_CHECK: 'accountingHealthCheck',
  PROVIDER_STATUS: 'accountingProviderStatus',
  ADMIN_ORG_SETTINGS: 'accountingAdminOrgSettings',
};
